import React, { Fragment } from "react"
import { string, shape, element, func, bool } from "prop-types"
import classNames from "classnames"
import ThemeConsumer from "../ThemeConsumer"

const ButtonImage = ({
  theme,
  image,
  preset,
  onClick,
  disabled,
  className,
  id
}) => {
  const classes =
    className ||
    classNames(
      { [theme[preset]]: preset },
      { [theme.buttonImage]: !preset },
      className
    )

  return (
    <Fragment>
      <button
        id={id}
        type="button"
        className={disabled ? theme.buttonImageDisabled : classes}
        onClick={onClick}
      >
        <img src={image.type} alt="" />
      </button>
    </Fragment>
  )
}

ButtonImage.propTypes = {
  image: element.isRequired,
  preset: string,
  onClick: func,
  theme: shape({
    button: string
  }),
  disabled: bool,
  id: string,
  className: string
}

ButtonImage.defaultProps = {
  theme: {},
  onClick: null,
  preset: "buttonImage",
  disabled: false
}

export default ThemeConsumer("UIButtonImage")(ButtonImage)



// WEBPACK FOOTER //
// ./src/shared/components/Button/ButtonImage.js